import type { GenerateMode } from '@/api/generate.api';

/** The generator page with a model already selected. `modelSlug` is the name the page's `?model=` param carries. */
export const generatorPath = (modelSlug: string) => `/generate?${new URLSearchParams({ model: modelSlug })}`;

/** The generator on the media type's default model, or the first one the user can pick when they can't pick the default. */
export const generatorModePath = (mode: GenerateMode) => `/generate?${new URLSearchParams({ mode })}`;
